import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=19707a4d&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/Dashboard/DashboardStyle.css?vue&type=style&index=0&id=19707a4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19707a4d",
  null
  
)

export default component.exports